<div class="flex flex-col h-full">
    <!-- Header -->
    <div class="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
        <div class="flex items-center gap-4">
            <div class="w-12 h-12 rounded-xl bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
                <mat-icon class="!w-6 !h-6 text-blue-600 dark:text-blue-400" [svgIcon]="'tabler_outline:file-type-xml'"></mat-icon>
            </div>
            <div>
                <h2 class="text-xl font-semibold text-gray-900 dark:text-white">
                    {{ title }}
                </h2>
                <p *ngIf="documentNumber" class="text-sm text-gray-600 dark:text-gray-400 mt-0.5">
                    Faktura: <span class="font-medium">{{ documentNumber }}</span>
                </p>
                <p *ngIf="ksefNumber && !documentNumber" class="text-xs text-gray-500 dark:text-gray-500 mt-0.5 font-mono">
                    {{ ksefNumber }}
                </p>
            </div>
        </div>
        <button 
            mat-icon-button 
            (click)="close()"
            matTooltip="Zamknij (Esc)"
            class="!text-gray-500 hover:!text-gray-700 dark:!text-gray-400 dark:hover:!text-gray-200">
            <mat-icon [svgIcon]="'tabler_outline:x'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-hidden p-6 flex flex-col min-h-0">
        
        <!-- Actions Bar -->
        <div class="flex items-center justify-between mb-4 pb-3 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
            <div class="flex items-center gap-4 text-sm text-gray-500 dark:text-gray-400">
                <span class="flex items-center gap-1.5">
                    <mat-icon class="!w-4 !h-4" [svgIcon]="'tabler_outline:file'"></mat-icon>
                    {{ xmlSizeKb }} KB
                </span>
                <span *ngIf="ksefNumber" class="flex items-center gap-1.5 font-mono text-xs">
                    <mat-icon class="!w-4 !h-4 text-green-600 dark:text-green-400" [svgIcon]="'tabler_outline:certificate'"></mat-icon>
                    {{ ksefNumber }}
                </span>
            </div>
            <div class="flex gap-2">
                <button 
                    mat-stroked-button 
                    (click)="copyToClipboard()"
                    matTooltip="Kopiuj do schowka"
                    class="!h-9">
                    <mat-icon class="!w-4 !h-4 mr-1" [svgIcon]="'tabler_outline:copy'"></mat-icon>
                    Kopiuj
                </button>
                <button 
                    mat-flat-button 
                    color="primary"
                    (click)="downloadXml()"
                    matTooltip="Pobierz plik XML"
                    class="!h-9">
                    <mat-icon class="!w-4 !h-4 mr-1" [svgIcon]="'tabler_outline:download'"></mat-icon>
                    Pobierz
                </button>
            </div>
        </div>

        <!-- XML Viewer with Syntax Highlighting -->
        <div class="xml-container bg-gray-900 rounded-lg flex-1 min-h-0">
            <textarea 
                fakturnia-highlight
                [code]="formattedXml"
                [lang]="'xml'"
                readonly>
            </textarea>
        </div>
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-end gap-3 p-6 border-t border-gray-200 dark:border-gray-700 flex-shrink-0 bg-gray-50 dark:bg-gray-800/50">
        <button 
            mat-stroked-button 
            (click)="close()">
            Zamknij
        </button>
    </div>
</div>
